import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Screens from '../../constants/routing/Screens';
import { SUITE_CALCULATOR } from '../../constants/tracking/Locations';
import { useAppSelector } from '../../reducers';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { suiteProductConfigurationsSelector } from '../../selectors/ProductConfigsSelectors';
import { crmSuiteProductLevelsSelector, crmSuiteProductLinesForProductLevelSelector } from '../../selectors/ProductsSelectors';
import AddonsAndServicesPickerList from '../plan-builder/AddonsAndServicesPickerList';
import SuitePlanPicker from '../plan-builder/SuitePlanPicker';
import Calculator from './Calculator';
import { Section } from '../common/SharedComponents';
export const SuiteCalculator = ({
  className,
  initialProductLevel
}) => {
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);
  const initialProductConfigurations = useAppSelector(state => {
    if (!hasPricingAndPurchasingSucceeded) return [];
    return suiteProductConfigurationsSelector(state, {
      productLevel: initialProductLevel
    });
  });
  const crmSuiteProductLevels = useAppSelector(crmSuiteProductLevelsSelector);
  const allCrmSuiteProductLines = useAppSelector(state => {
    return Array.from(crmSuiteProductLevels.reduce((acc, productLevel) => {
      const productLines = crmSuiteProductLinesForProductLevelSelector(state, {
        productLevel
      });
      productLines.forEach(productLine => acc.add(productLine));
      return acc;
    }, new Set()));
  });
  return /*#__PURE__*/_jsx(Section, {
    hideOverflow: false,
    children: /*#__PURE__*/_jsx(Calculator, {
      planBuilderProps: {
        initialProductConfigurations,
        requiredProductLines: allCrmSuiteProductLines,
        trackingSource: SUITE_CALCULATOR,
        screen: Screens.SUITE,
        showDiscountedPricesInUnitsPicker: true
      },
      className: className,
      hideCrmSuiteAlert: true,
      planSelectorComponent: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SuitePlanPicker, {}), /*#__PURE__*/_jsx(AddonsAndServicesPickerList, {
          compact: true,
          defaultOpen: false,
          showServicesSection: false,
          screen: Screens.SUITE,
          showLeadingDivider: true
        })]
      })
    })
  });
};